import {log} from '../log';

const isMobile = {
    Android: () => navigator.userAgent.match(/Android/i),
    iOS: () => navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iOS/i),
    any: () => isMobile.Android() || isMobile.iOS(),
};

const isDesktop = {
    Windows: () => navigator.userAgent.match(/Windows/i),
};

const isMobileAndroidDevice = () => !!isMobile.Android();

const isDesktopWindows = () => !!isDesktop.Windows();

const isBluetoothSupported = () => !!navigator.bluetooth;

const isBluetoothEventListenersSupported = () =>
    navigator.bluetooth.addEventListener && navigator.bluetooth.removeEventListener;

const isUsbSupported = () => !!navigator.hid;

const checkBluetoothAvailability = async () => {
    try {
        let isBluetoothAvailable = true;

        if (navigator.bluetooth?.getAvailability) {
            isBluetoothAvailable = await navigator.bluetooth.getAvailability();
        }

        log.info(`userDeviceService: checkBluetoothAvailability isBluetoothAvailable: ${isBluetoothAvailable}`);
        // TODO: uncomment this when we have a way to set the state
        // dispatch(setIsBluetoothAvailable(isBluetoothAvailable));
    } catch (e) {
        log.info(`userDeviceService: checkBluetoothAvailability error: ${e}`);
    }
};

export default {
    checkBluetoothAvailability,
    isBluetoothEventListenersSupported,
    isBluetoothSupported,
    isUsbSupported,
    isDesktopWindows,
    isMobileAndroidDevice,
};
